import BankList from '../BankList/BankList';
import { IBankList } from '../BankList/BankList';
import { HeadTitle } from 'oui';

interface IPartnersListProps {
  title: string;
  partners: IBankList[];
}
const PartnersList = ({ title, partners }: IPartnersListProps) => {
  const removeDuplicate = (arr: any, param: string) => {
    const map = new Map();
    arr.forEach((item: any) => {
      if (!map.has(item[param])) {
        map.set(item[param], item);
      }
    });
    return Array.from(map.values());
  };

  const duplicateRemovedList = removeDuplicate(partners, 'compNm');

  return (
    <>
      <HeadTitle textTitle={title} />
      <BankList partners={duplicateRemovedList} />
    </>
  );
};

export default PartnersList;
